import { Controller } from "@hotwired/stimulus"

// Toggles every checkbox tagged as `checkbox-toolbar-target=checkbox` inside
// the controller scope. Used by the eligibility proponent picker to offer
// "select all" / "clear" affordances without external dependencies.
export default class extends Controller {
  static targets = ["checkbox"]

  selectAll(event) {
    if (event) event.preventDefault()
    this.checkboxTargets.forEach((cb) => { cb.checked = true })
  }

  selectNone(event) {
    if (event) event.preventDefault()
    this.checkboxTargets.forEach((cb) => { cb.checked = false })
  }
}
